// The single source of plan names, prices and limits: shared/plans.json (versioned).
import catalog from '../../../shared/plans.json';
import type { Me } from './api';

export const CATALOG = catalog;
export type Interval = 'month' | 'year';
export type PlanId = 'free' | 'pro' | 'studio';
export type PaidPlanId = 'pro' | 'studio';
export const PLAN_IDS: PlanId[] = ['free', 'pro', 'studio'];
export const PAID_PLAN_IDS: PaidPlanId[] = ['pro', 'studio'];
export const FREE = catalog.plans.free;
export const PRO = catalog.plans.pro;
export const STUDIO = catalog.plans.studio;
export const PLANS = catalog.plans;
export type Limits = typeof FREE.limits;

/** Yearly saving vs 12 monthly payments for one plan, rounded down to a whole percent (computed, never hardcoded). */
export const yearlySavingPct = (id: PaidPlanId) => Math.floor((1 - PLANS[id].prices.year / (PLANS[id].prices.month * 12)) * 100);
/** "Save up to N%" across the paid plans. */
export const maxYearlySavingPct = Math.max(...PAID_PLAN_IDS.map(yearlySavingPct));

export const isPaid = (me: Me | null | undefined) => !!me && me.entitlement.plan !== 'free';
export const planName = (me: Me) => me.entitlement.planName ?? (PLANS as Record<string, { name: string }>)[me.entitlement.plan]?.name ?? me.entitlement.plan;
export const isPaidPlanId = (v: string | undefined): v is PaidPlanId => v === 'pro' || v === 'studio';
